import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { AppKitNetwork, arbitrum, sepolia } from '@reown/appkit/networks'
import { http } from 'wagmi'
import logo from '../assets/logo.svg'
import { ethers } from 'ethers'

//https://cloud.walletconnect.com/app/project?uuid=fc5638675b78803f84a718b7b390ecd2
const walletConnectProjectId = 'fc5638675b78803f84a718b7b390ecd2'

const projectId = walletConnectProjectId
const ALCHEMY_KEY =
  import.meta.env.VITE_ALCHEMY_API_KEY || 'eO8AxZ0V_cuoqgNtGcBliyUXh5Xol6a6'

export const IS_TESTNET = import.meta.env.VITE_ENV === 'dev'
console.log('IS Testnet: ', IS_TESTNET)

export const defaultNetwork: AppKitNetwork = IS_TESTNET ? sepolia : arbitrum

export const sepoliaProvider = new ethers.JsonRpcProvider(
  `https://eth-sepolia.g.alchemy.com/v2/eO8AxZ0V_cuoqgNtGcBliyUXh5Xol6a6`
)
export const arbitrumProvider = new ethers.JsonRpcProvider(
  `https://arb-mainnet.g.alchemy.com/v2/${ALCHEMY_KEY}`
)
export const provider = IS_TESTNET ? sepoliaProvider : arbitrumProvider

const metadata = {
  name: 'Secrets Hideaway',
  description: 'Secrets Hideaway Resort & Spa',
  url: window.location.href,
  icons: [logo]
}

export const networks: [AppKitNetwork, ...AppKitNetwork[]] = IS_TESTNET
  ? [sepolia]
  : [arbitrum]

export const generalConfig = {
  projectId,
  metadata,
  networks
}

const TESTNET_TRANSPORTS = {
  [sepolia.id]: http(`https://eth-sepolia.g.alchemy.com/v2/${ALCHEMY_KEY}`)
}

const MAINNET_TRANSPORTS = {
  [arbitrum.id]: http(
    `https://arb-mainnet.g.alchemy.com/v2/eO8AxZ0V_cuoqgNtGcBliyUXh5Xol6a6`
  )
}

export const wagmiAdapter = new WagmiAdapter({
  ...generalConfig,
  transports: IS_TESTNET ? TESTNET_TRANSPORTS : MAINNET_TRANSPORTS
})

export const wagmiConfig = wagmiAdapter.wagmiConfig
